import type { SlotAwareField } from '@cli-types/core-engine/schema-reader.js'
import { walkSlotAwareField } from './walk-slot-aware-field.js'

export function walkHeight(field: SlotAwareField, fieldPath: string, errors: string[]): void {
  walkSlotAwareField(field, fieldPath, errors, {
    checkField: (current, currentPath, currentErrors) => {
      if (current.height !== undefined && current.height !== 'auto' && current.height !== 'fill') {
        currentErrors.push(
          `Field "${currentPath}" has invalid height="${String(current.height)}". Expected "auto" or "fill".`
        )
      }
    },
    descendTabSlots: true
  })
}
